import { Spinner } from '@/components/Spinner';
import { useBankInformation } from '../hooks/useBankInformation';
import { AddBankInfoOptions } from './admin.constant';
import { AddBankInfoForm } from './AddBankInfoForm';
import type { AddBankInfoDefaultValues } from './AddBankInfoForm';

const emptyDefaults: AddBankInfoDefaultValues = {
  bankType: AddBankInfoOptions[0].value,
  bankName: '',
  branchCode: '',
  accountSymbol: '',
  accountNumber: '',
  accountName: '',
  branchName: '',
};

export const AddBankInfo = () => {
  const { bankInformation, isPending: isLoading } = useBankInformation();

  if (isLoading) return <Spinner />;

  const defaultValues: AddBankInfoDefaultValues = bankInformation
    ? {
        bankType: bankInformation.bankType,
        bankName: bankInformation.bankName ?? '',
        branchName: bankInformation.branchName ?? '',
        branchCode: bankInformation.branchCode ?? '',
        accountNumber: bankInformation.accountNumber ? String(bankInformation.accountNumber) : '',
        accountSymbol: bankInformation.accountSymbol ?? '',
        accountName: bankInformation.accountName ?? '',
      }
    : emptyDefaults;

  return <AddBankInfoForm defaultValues={defaultValues} />;
};
